import React, { useState, lazy, Suspense } from 'react';
import { IconButton, useTheme } from '@mui/material';
import useIsUserEditorOrAdmin from '@/DesignSystem/hooks/useIsUserEditorOrAdmin';

// Componente ligero del trigger que siempre se renderiza
const ShareUrlModalTrigger = ({ onClick, triggerProps, theme }) => {
    const shareIcon = (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="1em"
            height="1em"
            viewBox="0 0 24 24"
            style={{ color: theme.palette.text.secondary }}
        >
            <path
                fill="currentColor"
                d="M16.61 21q-.994 0-1.687-.695q-.692-.696-.692-1.69q0-.15.132-.757l-7.197-4.273q-.324.374-.793.587t-1.007.213q-.986 0-1.676-.702T3 12t.69-1.683t1.676-.702q.537 0 1.007.213t.793.588l7.198-4.255q-.07-.194-.101-.385q-.032-.192-.032-.392q0-.993.697-1.689Q15.625 3 16.62 3t1.688.697T19 5.389t-.695 1.688t-1.69.692q-.542 0-1-.222t-.78-.597l-7.199 4.273q.07.194.101.386q.032.191.032.391t-.032.391t-.1.386l7.198 4.273q.323-.375.78-.597q.458-.222 1-.222q.994 0 1.69.696q.695.698.695 1.693t-.697 1.688t-1.692.692"
            />
        </svg>
    );

    return (
        <IconButton onClick={onClick} sx={{ p: 0.5 }} aria-label="Compartir" {...triggerProps}>
            {shareIcon}
        </IconButton>
    );
};

// Modal cargado de forma lazy
const ShareUrlModalContent = lazy(() => import('./share-url-modal-content'));

const ShareUrlModal = ({ open, onClose, title = 'Compartir', showTrigger = true, triggerProps = {} }) => {
    const theme = useTheme();
    const [internalOpen, setInternalOpen] = useState(false);

    const isAdminOrEditor = useIsUserEditorOrAdmin();

    const handleOpen = () => {
        setInternalOpen(true);
    };

    const handleClose = () => {
        setInternalOpen(false);
        onClose?.();
    };

    const isControlled = open !== undefined;
    const modalOpen = isControlled ? open : internalOpen;
    const handleModalClose = isControlled ? onClose : handleClose;

    const triggerButton = showTrigger && (
        <ShareUrlModalTrigger onClick={handleOpen} triggerProps={triggerProps} theme={theme} />
    );

    if (!isAdminOrEditor) {
        return null;
    }

    return (
        <>
            {triggerButton}
            {modalOpen && (
                <Suspense fallback={null}>
                    <ShareUrlModalContent
                        open={modalOpen}
                        onClose={handleModalClose}
                        title={title}
                        theme={theme}
                    />
                </Suspense>
            )}
        </>
    );
};

export default ShareUrlModal;
